import { useMutation } from 'react-query';
import { projectPlanningService } from 'hq/services';
import { useInvalidateQuery } from 'shared/hooks/query-hooks/useInvalidateQuery';
import { QUERY_KEYS } from 'api/query-keys';

export const useArchiveProject = () => {
  const mutationFn = async (projectId: string) =>
    await projectPlanningService.archiveProject(projectId);
  const invalidateQuery = useInvalidateQuery();
  return useMutation(mutationFn, {
    onSuccess: () => {
      invalidateQuery(QUERY_KEYS.projects());
    },
  });
};
